import { useMutation, useQueryClient } from "react-query";
import yearPlanAPI from "../../../api/yearPlanAPI";

export const useDeleteYearPlan = () => {
  const queryClient = useQueryClient();

  return useMutation(yearPlanAPI.deleteYearPlan, {
    onSuccess: () => queryClient.invalidateQueries("yearPlans"),
    onError: (error) => console.log("Delete error: ", error),
  });
};
